import { disableBodyScroll } from 'body-scroll-lock';
import React, { useEffect, useRef } from 'react';

import type { StandardModalProps } from '~/legacy/types';
import { bem } from '~/legacy/utils';

import ModalFrame from './ModalFrame';

const StandardModal = ({
  maxWidth,
  isFullScreen,
  preventBodyScrollLock,
  onCloseClick,
  children,
  centered,
  setBorderRadius,
  disableClickOutside,
  hideClose,
  isFullBody,
  background,
  isFullWidth,
  positionSemantic,
  showBorder
}: StandardModalProps) => {
  const targetRef: React.MutableRefObject<HTMLDivElement | null> = useRef(null);

  useEffect(() => {
    if (!preventBodyScrollLock) {
      targetRef.current && disableBodyScroll(targetRef.current);
    }
  }, [targetRef, preventBodyScrollLock]);

  return (
    <div
      data-testid="standard-modal"
      ref={targetRef}
      className={bem('standard-modal', {
        isFullScreen,
        maxWidth
      })}
    >
      <div className="standard-modal__wrapper">
        <div className="standard-modal__position">
          <ModalFrame
            onCloseClick={onCloseClick}
            centered={centered}
            setBorderRadius={setBorderRadius}
            disableClickOutside={disableClickOutside}
            hideClose={hideClose}
            isFullBody={isFullBody}
            background={background}
            isFullWidth={isFullWidth}
            positionSemantic={positionSemantic}
            showBorder={showBorder}
          >
            {children}
          </ModalFrame>
        </div>
      </div>
    </div>
  );
};

export default StandardModal;
